// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HelpDrawer - Right-side slide-over panel */

.help-drawer-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.help-drawer-backdrop.open {
  opacity: 1;
  pointer-events: auto;
}

.help-drawer-panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 400px;
  max-width: 100vw;
  background: #1a1a1a;
  border-left: 1px solid #333;
  z-index: 1001;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.help-drawer-panel.open {
  transform: translateX(0);
}

/* Header */
.help-drawer-header {
  padding: 24px 24px 20px;
  border-bottom: 1px solid #333;
  flex-shrink: 0;
}

.help-drawer-header-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.help-drawer-title {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.help-drawer-close {
  background: none;
  border: none;
  color: #b0b0b0;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.help-drawer-close:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

.help-drawer-subtitle {
  color: #b0b0b0;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

/* Content sections */
.help-drawer-content {
  padding: 24px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.help-drawer-section {
  background: #111;
  border: 1px solid #333;
  border-radius: 8px;
  padding: 20px;
  transition: border-color 0.2s ease;
}

.help-drawer-section:hover {
  border-color: rgba(33, 138, 255, 0.5);
}

.help-drawer-section-title {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.help-drawer-section-description {
  color: #b0b0b0;
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 16px 0;
}

.help-drawer-section-description ul {
  margin: 8px 0 0 0;
  padding-left: 16px;
  list-style: disc;
}

.help-drawer-section-description li {
  margin-bottom: 4px;
}

.help-drawer-email {
  color: #218aff;
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 12px 0;
  word-break: break-all;
}

/* Primary button (Schedule a Call) */
.help-drawer-btn-primary {
  display: inline-block;
  padding: 12px 24px;
  background: #218aff;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  width: 100%;
}

.help-drawer-btn-primary:hover {
  background: #1a7aef;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.3);
}

.help-drawer-btn-primary:active {
  transform: translateY(0);
}

/* Secondary button (Email, Reddit) */
.help-drawer-btn-secondary {
  display: inline-block;
  padding: 10px 20px;
  background: transparent;
  color: #b0b0b0;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #444;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  width: 100%;
}

.help-drawer-btn-secondary:hover {
  background: #333;
  color: #fff;
  border-color: #555;
}

.help-drawer-btn-secondary:active {
  transform: translateY(0);
}

/* Responsive */
@media (max-width: 768px) {
  .help-drawer-panel {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Help/HelpDrawer.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,2BAA2B;EAC3B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qCAAqC;AACrC;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE;IACE,WAAW;EACb;AACF","sourcesContent":["/* HelpDrawer - Right-side slide-over panel */\n\n.help-drawer-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 1000;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n}\n\n.help-drawer-backdrop.open {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.help-drawer-panel {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 400px;\n  max-width: 100vw;\n  background: #1a1a1a;\n  border-left: 1px solid #333;\n  z-index: 1001;\n  transform: translateX(100%);\n  transition: transform 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.help-drawer-panel.open {\n  transform: translateX(0);\n}\n\n/* Header */\n.help-drawer-header {\n  padding: 24px 24px 20px;\n  border-bottom: 1px solid #333;\n  flex-shrink: 0;\n}\n\n.help-drawer-header-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 8px;\n}\n\n.help-drawer-title {\n  color: #fff;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.help-drawer-close {\n  background: none;\n  border: none;\n  color: #b0b0b0;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.help-drawer-close:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.help-drawer-subtitle {\n  color: #b0b0b0;\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* Content sections */\n.help-drawer-content {\n  padding: 24px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.help-drawer-section {\n  background: #111;\n  border: 1px solid #333;\n  border-radius: 8px;\n  padding: 20px;\n  transition: border-color 0.2s ease;\n}\n\n.help-drawer-section:hover {\n  border-color: rgba(33, 138, 255, 0.5);\n}\n\n.help-drawer-section-title {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0 0 8px 0;\n}\n\n.help-drawer-section-description {\n  color: #b0b0b0;\n  font-size: 14px;\n  line-height: 1.6;\n  margin: 0 0 16px 0;\n}\n\n.help-drawer-section-description ul {\n  margin: 8px 0 0 0;\n  padding-left: 16px;\n  list-style: disc;\n}\n\n.help-drawer-section-description li {\n  margin-bottom: 4px;\n}\n\n.help-drawer-email {\n  color: #218aff;\n  font-size: 14px;\n  font-weight: 500;\n  margin: 0 0 12px 0;\n  word-break: break-all;\n}\n\n/* Primary button (Schedule a Call) */\n.help-drawer-btn-primary {\n  display: inline-block;\n  padding: 12px 24px;\n  background: #218aff;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n  width: 100%;\n}\n\n.help-drawer-btn-primary:hover {\n  background: #1a7aef;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(33, 138, 255, 0.3);\n}\n\n.help-drawer-btn-primary:active {\n  transform: translateY(0);\n}\n\n/* Secondary button (Email, Reddit) */\n.help-drawer-btn-secondary {\n  display: inline-block;\n  padding: 10px 20px;\n  background: transparent;\n  color: #b0b0b0;\n  font-size: 14px;\n  font-weight: 500;\n  border: 1px solid #444;\n  border-radius: 8px;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n  width: 100%;\n}\n\n.help-drawer-btn-secondary:hover {\n  background: #333;\n  color: #fff;\n  border-color: #555;\n}\n\n.help-drawer-btn-secondary:active {\n  transform: translateY(0);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .help-drawer-panel {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
